module.exports = __webpack_public_path__ + "img/browser.b784febb.svg";